import React, { FC, useContext, useState } from 'react';
import { UiStateContext } from '../../context/UiStateContext';
import { UserContext } from '../../context/UserContext';
import { Divider } from '../Divider';
import { IconLink } from '../IconLink';
import { Spacer } from '../Spacer';
import { Typography } from '../Typography';
import { Button } from '../Button';

export const PropertiesNoResults = ({ handleSearchAgain, locationName }) => {
  const { user } = useContext(UserContext);
  const { setActiveBlade } = useContext(UiStateContext);

  const handleCreateAlert = () => {
    // Check if user is logged in

    // if yes then open create alert blade

    if (user) {
      setActiveBlade('createPropertyAlert');
    } else {
      setActiveBlade('createPropertyAlertLoginOrRegister');
    }
  };

  return (
    <Spacer>
      <Typography component="h2" variant="lead">
        Sorry, we cannot find any properties matching your search right now.
        <br />
        Try widening your search criteria{' '}
        {handleSearchAgain ? `or extend your search to a 3 mile radius of ${locationName || 'the location'}` : ''}.
      </Typography>
      {handleSearchAgain && <Button label="Extend search" arrowRight onClick={(e) => handleSearchAgain(e)} />}
      <Divider />
      <Spacer spacing="half">
        <Typography component="h3" variant="titleSmall">
          Get notified when properties match your search
        </Typography>
        <IconLink arrowLeft label="Create an alert" onClick={() => handleCreateAlert()} type="button" />
      </Spacer>
    </Spacer>
  );
};
